import { CloudDownloadRounded } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import useGenerateClientDocuments from "../../hooks/useGenerateClientDocuments";
import { CustomButton } from "../buttons/CustomButton";
import SnackbarError from "../snackbars/SnackbarError";
import SnackbarPositive from "../snackbars/SnackbarPositive";

const FEATURE_ENABLED_STATUS = [5, 4, 3, 7];

const GenerateClientDocuments = ({ clientStatus, clientId, clientName }) => {
  const { generateDocuments, reset, isPending, isSuccess, isError } =
    useGenerateClientDocuments({});

  useEffect(() => {
    if (!isSuccess) return;

    const timer = setTimeout(() => {
      if (isSuccess) {
        reset();
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isSuccess, reset]);

  return (
    <>
      <CustomButton
        disabled={!FEATURE_ENABLED_STATUS.includes(clientStatus)}
        label="Pobierz dokumenty"
        icon={
          isPending ? (
            <CircularProgress sx={{ color: "white" }} size={"1rem"} />
          ) : (
            <CloudDownloadRounded />
          )
        }
        handleClick={() => generateDocuments({ clientId, clientName })}
      />
      <SnackbarError
        error={
          isError ? "Wystąpił błąd w trakcie generowania plików klienta" : null
        }
        onClose={reset}
      />

      <SnackbarPositive
        isOpen={isSuccess}
        handleCloseSnackbar={reset}
        snackbarMessage={"Rozpoczęto pobieranie pliku"}
      />
    </>
  );
};
export default GenerateClientDocuments;
